import { DashboardModel } from '@/http/models/Dashboard'

import { useEffect, useState } from 'react'

import { DashboardModel as DashboardType } from '@/types'

export const useDashboard = () => {
  const [data, setData] = useState<DashboardType.DashboardResult | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchDashboard = async () => {
    setLoading(true)
    setError(null)
    const response = await DashboardModel.getDashboard()
    if (response.success && response.data) {
      setData(response.data.result)
    } else {
      setError(response.error?.data?.message || 'Failed to fetch dashboard data')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchDashboard()
  }, [])

  return {
    data,
    loading,
    error,
    refresh: fetchDashboard,
  }
}
